export default __webpack_public_path__ + "static/media/integrationManage.6f9121b3.png";